'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var MapContext = require('./MapContext.js');

/*global google*/
var MarkerBounds = function () {
    var ctx = react.useContext(MapContext.default);
    var isReady = ctx.isReady;
    var map = ctx.map;
    var markers = ctx.markers;
    react.useEffect(function () {
        if (isReady && markers && markers.length > 0) {
            var bounds_1 = new window.google.maps.LatLngBounds();
            markers.map(function (marker) {
                return bounds_1.extend(marker.getPosition());
            });
            map === null || map === void 0 ? void 0 : map.setCenter(bounds_1.getCenter());
            map === null || map === void 0 ? void 0 : map.fitBounds(bounds_1);
        }
    }, [isReady, map, markers]);
    return jsxRuntime.jsx(jsxRuntime.Fragment, {});
};
var MarkerBounds$1 = MarkerBounds;

exports.default = MarkerBounds$1;
//# sourceMappingURL=MarkerBounds.js.map
